import { IModel } from '@cbgms/api'
import Chip from '@mui/material/Chip'
import Grid from '@mui/material/Grid'
import { useOnEnterHandler } from '@carsys/ui/src/helpers/keyboard/use-on-enter-handler'

interface ModelChipProps {
  model: IModel
  onModelSelect: (modelKey: string, model: IModel) => void
  focus?: boolean
  selectedKey?: string
}

export function ModelChip({ model, onModelSelect, focus, selectedKey }: ModelChipProps) {
  useOnEnterHandler(focus, () => onModelSelect(model.ModelID, model))

  return (
    <Grid item display='flex' flexDirection='column'>
      <Chip
        tabIndex={focus ? 0 : -1}
        sx={{ flex: 1 }}
        onClick={() => onModelSelect(model.ModelID, model)}
        data-testid='select-chip-item'
        color={!!selectedKey && selectedKey === model.ModelID ? 'primary' : 'default'}
        className={focus ? 'Mui-focusVisible' : ''}
        label={model.ModelName}
      />
    </Grid>
  )
}
